<template>
  <div class="p-0 m-0"> 
    <div class="text-input">
      <label><b>{{label}}</b></label>
      <div @click="toggleOrderSearchModal" class="pointer input-group">
        <input 
          :type="type"
          class="form-control pointer" 
          :disabled="disabled"
          :placeholder="placeholder"  
          :style="customStyles"
          v-model="displayText"
          @input="updateValue" 
          :aria-label="{label}">
          <div class="input-group-append pointer">
            <span class="input-group-text"><i class="fa fa-search" title="order-search"  aria-hidden="true"></i></span>
          </div>
      </div>
    </div>
    
      <OrderComboboxSearch
        ref="orderSearchDropdown"
        @orderSelected="orderSelected"
        :currentCustomerId="currentCustomerId"
        :value="currentOrder.Id"
      />
  </div>
</template>

<script>
import BasicDataGrid            from './BasicDataGrid.vue';
import OrderComboboxSearch   from './OrderComboboxSearch.vue';

export default {
  name: "AdvancedOrderSearch",
  components:{
    BasicDataGrid,
    OrderComboboxSearch,
  },
  props: {
     label: {
        type: String,
     },
     readOnly: {
       type: Boolean,
       default: false
     },
     placeholder: {
        type: String,
     },
     disabled: {
        type: Boolean,
        default: false,
     },
     value: {
        type: String,
        default: ""
     },
     type: {
        type: String,
        default: 'text'
     },
     customStyles: {
         type: Object,
     },
     currentCustomerId:{
       type: Number,
       default: null
     }
  },
  data(){
    return{
      displayText: null,
      loading: false,
      currentOrder: {
        WorksheetName: '',
        Id: null
      },
    }
    
  },
  methods:{
    updateValue(){
      this.$emit('change', this.currentOrder)
    },
    orderSelected(order){
      console.log('order, aos', order)
      this.currentOrder = {Id: order.Id, WorksheetName: order.WorksheetName, CustomerId: order.CustomerId};
      
    },
    toggleOrderSearchModal(){
      if(this.readOnly) return;
      this.$refs.orderSearchDropdown.toggle()
    },
  },
  computed: {
    orderOptions() {
      return this.orders
    }
  },
  watch: {
    currentOrder: function(){
      this.$emit('change', this.currentOrder)
    },
    value: function(){
      this.displayText = this.value;
    }
  },
  created(){
    this.displayText = this.value;
  }
}
</script>

<style lang="scss" scoped>
  
  .pointer{
    cursor: pointer;
  }
</style>